export const SHIFTS = [
  { id: "shift1", name: "Day Shift", start: 7, end: 15, label: "7 AM - 3 PM" },
  { id: "shift2", name: "Evening Shift", start: 15, end: 23, label: "3 PM - 11 PM" },
  { id: "shift3", name: "Night Shift", start: 23, end: 7, label: "11 PM - 7 AM" }
];

export const DAYS_OF_WEEK = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
